import { createSelector } from 'reselect';
const questionsSelector = (state) => state.faqModel.questions;
export const faqSelector = createSelector(questionsSelector, (state, count) => count, (questions, count) => {
    return count === 'all' ? questions : questions.slice(0, count);
});
export const allQuestionsCountSelector = (state) => state.faqModel.questions.length;
